import { HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { EnvironmentService } from 'app/shared/common/services/env.service';
import { Observable } from 'rxjs';
import { IncidentService as IncidentServiceV2 } from 'app/shared/api/generated/v2/incident/api/incident.service';
import { OrdersService as OrdersServiceV2 } from 'app/shared/api/generated/v2/incident/api/orders.service';
import {
  Tag,
  BaseIncidentCollectionTOV2,
  CreateIncidentTOV2,
  CreateNonSapOrderFeedbackTO,
  CreateOrderTO, CreateRejectOrderFeedbackTOV2,
  IncidentCollectionTOV2, IncidentFilterRequestV2, IncidentFilterValuesV2,
  IncidentTOV2,
  LuxdataDeeplinkResponseTO,
  OrderfeedbackService,
  OrderTO,
  StateHistoryService,
  StateHistoryTO,
  StatusGroup,
  ValidateSapOrderFeedbackTO, IncidentManuallyCloseStateTOV2, ProcessingByTO,
} from 'app/shared/api/generated/v2/incident';
import { ViewMode } from 'app/shared/common/models/enums/view-mode/view-mode';
import { UserRoleUtils } from '../../shared/common/services/user.role.utils';
import { User } from '../../shared/common/models/user';

@Injectable({
  providedIn: 'root',
})
export class IncdntService {
  constructor(
    private stateHistoryService: StateHistoryService,
    private incidentServiceV2: IncidentServiceV2,
    private orderServiceV2: OrdersServiceV2,
    private orderFeedbackService: OrderfeedbackService
  ) {
    this.orderServiceV2.configuration.basePath =
      EnvironmentService.getEnvironment().incidentService;
    this.orderFeedbackService.configuration.basePath =
      EnvironmentService.getEnvironment().incidentService;
    this.incidentServiceV2.configuration.basePath =
      EnvironmentService.getEnvironment().incidentService;
    this.stateHistoryService.configuration.basePath =
      EnvironmentService.getEnvironment().incidentService;
  }

  public createIncident(incident: CreateIncidentTOV2): Observable<object> {
    return this.incidentServiceV2.createByIdV2(incident, 'response');
  }

  exportIncidents(
    viewMode: ViewMode,
    filter?: IncidentFilterRequestV2,
    statusGroup?: StatusGroup
  ): Observable<HttpResponse<any>> {
    return this.incidentServiceV2.exportCsvV2(viewMode,
      filter.assignee != null && filter.assignee !== '' ? filter.assignee : null,
      filter.cities,
      filter.deficit,
      filter.externalMessageReadStatus,
      filter.fromDate,
      filter.hasComplaint === false ? null : filter.hasComplaint,
      filter.incidentStatus,
      filter.internalMessageReadStatus,
      filter.isNotTransferredToLuxData === false ? null : filter.isNotTransferredToLuxData,
      filter.lightingOrControlCabinetNo != null &&
        filter.lightingOrControlCabinetNo !== ''
        ? filter.lightingOrControlCabinetNo
        : null,
      filter.netArea,
      filter.orderDueDatePassed,
      filter.orderTypes,
      null,
      filter.processingBy,
      filter.incidentRelationTypes,
      null,
      filter.sortBy,
      filter.sortDir,
      statusGroup,
      filter.street != null && filter.street !== '' ? filter.street : null,
      filter.symptoms,
      filter.tags,
      filter.toDate,
      'response'
    );
  }

  public updateIncident(id: string, incident: any): Observable<object> {
    return this.incidentServiceV2.updateByIdV2(id, incident, 'response');
  }

  public createOrder(incId: string, data: CreateOrderTO): Observable<object> {
    return this.orderServiceV2.createOrderV2(incId, data);
  }

  public getInProgressIncidents(
    filter?: IncidentFilterRequestV2,
    page?: number,
    size?: number
  ): Observable<BaseIncidentCollectionTOV2> {
    return this.incidentServiceV2.getInProgress(
      filter.assignee != null && filter.assignee !== '' ? filter.assignee : null,
      filter.cities,
      filter.deficit,
      filter.externalMessageReadStatus,
      filter.fromDate,
      filter.hasComplaint === false ? null : filter.hasComplaint,
      filter.incidentStatus,
      filter.internalMessageReadStatus,
      filter.isNotTransferredToLuxData === false ? null : filter.isNotTransferredToLuxData,
      filter.lightingOrControlCabinetNo != null &&
        filter.lightingOrControlCabinetNo !== ''
        ? filter.lightingOrControlCabinetNo
        : null,
      filter.netArea,
      filter.orderDueDatePassed,
      filter.orderTypes,
      page ? page : 0,
      filter.processingBy,
      filter.incidentRelationTypes,
      size ? size : 10,
      filter.sortBy,
      filter.sortDir,
      StatusGroup.InProgress,
      filter.street != null && filter.street !== '' ? filter.street : null,
      filter.symptoms,
      filter.tags,
      filter.toDate
    );
  }

  public getCompanyInProgressIncidents(
    filter?: IncidentFilterRequestV2,
    page?: number,
    size?: number
  ): Observable<BaseIncidentCollectionTOV2> {
    return this.incidentServiceV2.getCompanyInProgress(
      filter.assignee != null && filter.assignee !== '' ? filter.assignee : null,
      filter.cities,
      filter.deficit,
      filter.externalMessageReadStatus,
      filter.fromDate,
      filter.hasComplaint === false ? null : filter.hasComplaint,
      filter.incidentStatus,
      filter.internalMessageReadStatus,
      filter.isNotTransferredToLuxData === false ? null : filter.isNotTransferredToLuxData,
      filter.lightingOrControlCabinetNo != null &&
      filter.lightingOrControlCabinetNo !== ''
        ? filter.lightingOrControlCabinetNo
        : null,
      filter.netArea,
      filter.orderDueDatePassed,
      filter.orderTypes,
      page ? page : 0,
      filter.processingBy,
      filter.incidentRelationTypes,
      size ? size : 10,
      filter.sortBy,
      filter.sortDir,
      StatusGroup.InProgress,
      filter.street != null && filter.street !== '' ? filter.street : null,
      filter.symptoms,
      filter.tags,
      filter.toDate
    );
  }

  public getOwnInProgressIncidents(
    filter?: IncidentFilterRequestV2,
    page?: number,
    size?: number,
    userName?: string
  ): Observable<BaseIncidentCollectionTOV2> {
    return this.incidentServiceV2.getOwnInProgress(
      filter.assignee != null && filter.assignee !== '' ? filter.assignee : null,
      filter.cities,
      filter.deficit,
      filter.externalMessageReadStatus,
      filter.fromDate,
      filter.hasComplaint === false ? null : filter.hasComplaint,
      filter.incidentStatus,
      filter.internalMessageReadStatus,
      filter.isNotTransferredToLuxData === false ? null : filter.isNotTransferredToLuxData,
      filter.lightingOrControlCabinetNo != null &&
        filter.lightingOrControlCabinetNo !== ''
        ? filter.lightingOrControlCabinetNo
        : null,
      filter.netArea,
      filter.orderDueDatePassed,
      filter.orderTypes,
      page ? page : 0,
      filter.processingBy,
      filter.incidentRelationTypes,
      size ? size : 10,
      filter.sortBy,
      filter.sortDir,
      StatusGroup.InProgress,
      filter.street != null && filter.street !== '' ? filter.street : null,
      filter.symptoms,
      filter.tags,
      filter.toDate
    );
  }

  public getCompletedIncidents(
    filter?: IncidentFilterRequestV2,
    page?: number,
    size?: number
  ): Observable<BaseIncidentCollectionTOV2> {
    return this.incidentServiceV2.getCompleted(
      filter.assignee != null && filter.assignee !== '' ? filter.assignee : null,
      filter.cities,
      filter.deficit,
      filter.externalMessageReadStatus,
      filter.fromDate,
      filter.hasComplaint === false ? null : filter.hasComplaint,
      filter.incidentStatus,
      filter.internalMessageReadStatus,
      filter.isNotTransferredToLuxData === false ? null : filter.isNotTransferredToLuxData,
      filter.lightingOrControlCabinetNo != null &&
        filter.lightingOrControlCabinetNo !== ''
        ? filter.lightingOrControlCabinetNo
        : null,
      filter.netArea,
      filter.orderDueDatePassed,
      filter.orderTypes,
      page ? page : 0,
      filter.processingBy,
      filter.incidentRelationTypes,
      size ? size : 10,
      filter.sortBy,
      filter.sortDir,
      StatusGroup.Completed,
      filter.street != null && filter.street !== '' ? filter.street : null,
      filter.symptoms,
      filter.tags,
      filter.toDate
    );
  }

  public getCompanyCompletedIncidents(
    filter?: IncidentFilterRequestV2,
    page?: number,
    size?: number
  ): Observable<BaseIncidentCollectionTOV2> {
    return this.incidentServiceV2.getCompanyCompleted(
      filter.assignee != null && filter.assignee !== '' ? filter.assignee : null,
      filter.cities,
      filter.deficit,
      filter.externalMessageReadStatus,
      filter.fromDate,
      filter.hasComplaint === false ? null : filter.hasComplaint,
      filter.incidentStatus,
      filter.internalMessageReadStatus,
      filter.isNotTransferredToLuxData === false ? null : filter.isNotTransferredToLuxData,
      filter.lightingOrControlCabinetNo != null &&
      filter.lightingOrControlCabinetNo !== ''
        ? filter.lightingOrControlCabinetNo
        : null,
      filter.netArea,
      filter.orderDueDatePassed,
      filter.orderTypes,
      page ? page : 0,
      filter.processingBy,
      filter.incidentRelationTypes,
      size ? size : 10,
      filter.sortBy,
      filter.sortDir,
      StatusGroup.Completed,
      filter.street != null && filter.street !== '' ? filter.street : null,
      filter.symptoms,
      filter.tags,
      filter.toDate
    );
  }

  public getIncidents(
    filter?: IncidentFilterRequestV2,
    page?: number,
    size?: number,
    viewMode?: ViewMode,
    user?: User
  ): Observable<BaseIncidentCollectionTOV2> {
    const isOperatorOrUser = UserRoleUtils.hasRoleOperatorOrUser(user);
    const isExtern = UserRoleUtils.hasRoleOperatorExtern(user);

    if (!viewMode || !user) { return; }

    if (isOperatorOrUser) {
      switch (viewMode) {
        case ViewMode.ALL:
          return this.getInProgressIncidents(filter, page, size);
        case ViewMode.OWN:
          return this.getOwnInProgressIncidents(filter, page, size);
        case ViewMode.ARCHIVED:
          return this.getCompletedIncidents(filter, page, size);
        default:
          return;
      }
    }

    if (isExtern) {
      switch (viewMode) {
        case ViewMode.ALL:
          return this.getCompanyInProgressIncidents(filter, page, size);
        case ViewMode.OWN:
          return this.getOwnInProgressIncidents(filter, page, size);
        case ViewMode.ARCHIVED:
          return this.getCompanyCompletedIncidents(filter, page, size);
        default:
          return;
      }
    }
  }

  public getIncidentById(incUuid: string): Observable<IncidentTOV2> {
    return this.incidentServiceV2.getByIdV2(incUuid);
  }

  public getOrdersByIncidentId(id: string): Observable<Array<OrderTO>> {
    return this.orderServiceV2.getOrdersForIncidentV2(id);
  }

  public setIncidentToRejectedNoContract(incUuid: string): Observable<void> {
    return this.incidentServiceV2.approveIncident(incUuid, {
      approvalState: 'REJECTED_NO_CONTRACT',
    });
  }
  public setIncidentToRejectedImminentDanger(
    incUuid: string
  ): Observable<void> {
    return this.incidentServiceV2.approveIncident(incUuid, {
      approvalState: 'REJECTED_IMMINENT_DANGER',
    });
  }
  public setIncidentToApprovedByEnBW(incUuid: string): Observable<void> {
    return this.incidentServiceV2.approveIncident(incUuid, {
      approvalState: 'APPROVED',
    });
  }

  public deleteIncident(incUuid: string): Observable<HttpResponse<any>> {
    return this.incidentServiceV2.deleteByIdV2(incUuid, 'response');
  }

  public unlinkChildIncident(incUuid: string): Observable<object> {
    return this.incidentServiceV2.unlinkParentIncidentByIdV2(incUuid);
  }

  public getChildrenOfIncident(
    incidentUuid: string
  ): Observable<IncidentCollectionTOV2> {
    return this.incidentServiceV2.getByParentIdV2(incidentUuid);
  }

  public setAssignee(
    incidentUuid: string,
    assignee: string
  ): Observable<HttpResponse<any>> {
    return this.incidentServiceV2.setAssigneeV2(
      incidentUuid,
      {
        assignee,
      },
      'response'
    );
  }

  public setResponsible(
    incidentUuid: string,
    responsible: string
  ): Observable<HttpResponse<any>> {
    return this.incidentServiceV2.setResponsible(
      incidentUuid,
      {
        responsible,
      },
      'response'
    );
  }

  public setTag(
    incidentUuid: string,
    tags: Array<Tag>
  ): Observable<HttpResponse<any>> {
    return this.incidentServiceV2.setTagV2(
      incidentUuid,
      { tags },
      'response'
    );
  }

  /**
   * Retrieves the direct LuxData Easy deeplink URL for the specified incident.
   *
   * @param incUuid - Incident UUID
   * @returns Observable resolving with {@link LuxdataDeeplinkResponseTO} containing the direct URL and featureId
   */
  public getLuxdataDeeplink(incUuid: string): Observable<LuxdataDeeplinkResponseTO> {
    return this.incidentServiceV2.getLuxdataDeeplink(incUuid);
  }

  public editIncidentOrder(orderId: string, order: any): Observable<any> {
    return this.orderServiceV2.updateOrderDependingOnStateAndTypeV2(
      orderId,
      order,
      'response'
    );
  }

  public createOrderFeedback(
    orderId: string,
    orderFeedback: CreateNonSapOrderFeedbackTO
  ): Observable<any> {
    return this.orderFeedbackService.createFeedbackForManualOrder(
      orderId,
      orderFeedback
    );
  }

  public rejectOrderFeedbackFromExternal(
    orderId: string,
    createRejectOrderFeedback: CreateRejectOrderFeedbackTOV2
  ): Observable<any> {
    return this.orderFeedbackService.rejectFeedbackFromExternalOperator(
      orderId,
      createRejectOrderFeedback
    );
  }

  public validateSapOrderFeedback(
    orderId: string,
    orderFeedbackId: number,
    validateFeedback: ValidateSapOrderFeedbackTO
  ): Observable<any> {
    return this.orderFeedbackService.validateFeedbackForSapOrder(
      orderId,
      orderFeedbackId,
      validateFeedback
    );
  }

  public setComplaintFlag(
    incUuid: string,
    hasComplaint: boolean
  ): Observable<any> {
    return this.incidentServiceV2.setComplaintFlagV2(
      incUuid,
      { hasComplaint },
      'response'
    );
  }

  public getStateHistoryV2ByIncidentId(incidentUuid: string): Observable<StateHistoryTO> {
    return this.stateHistoryService.getAllByIncidentIdV2(
      incidentUuid
    );
  }

  public setIncidentStateV2(
    incUuid: string,
    comment?: string
  ): Observable<object> {
    return this.stateHistoryService.addCommentByIdV2(
      incUuid,
      { comment },
      'response'
    );
  }

  public deleteIncidentProtocolV2(incUuid: string, processingId: number): Observable<object> {
    return this.stateHistoryService.deleteByStateIdV2(
      incUuid,
      processingId
    );
  }

  public updateIncidentProtocolV2(
    incUuid: string,
    processingID: number,
    processingHistory
  ): Observable<object> {
    return this.stateHistoryService.updateByStateIdV2(
      incUuid,
      processingID,
      processingHistory,
      'response'
    );
  }

  public getFilterValues(viewMode: ViewMode): Observable<IncidentFilterValuesV2> {
    return this.incidentServiceV2.getFilterValues(viewMode);
  }

  public reopenIncident(incUuid: string): Observable<any> {
    return this.incidentServiceV2.reopenIncident(incUuid, 'response');
  }

  public closeSapIncidentManually(incUuid: string, incidentStateToV2: IncidentManuallyCloseStateTOV2): Observable<any> {
    return this.incidentServiceV2.closeSapIncidentManually(incUuid, incidentStateToV2, 'response');
  }

  public updateProcessingByUsers(incidentUuid: string, processingByTO: ProcessingByTO): Observable<any> {
    return this.incidentServiceV2.setProcessingByV2(incidentUuid, processingByTO);
  }
}
